import { badgeById, type FinishRunResponse, shiftNet } from '@accra/shared';
import { PLAYER_VEHICLES } from '../content/playerVehicles';
import { routeById } from '../content/routes';
import type { RunState } from '../game/RunState';
import type { RunView } from '../game/RunView';
import { drawScoreCard, shareCardImage } from '../ui/share/scoreCard';
import type { RunPlan } from './runPlan';

/** Builds the score card from the finished shift (with a snapshot of the road) and sends it to WhatsApp or downloads it. */
export async function shareScoreCard(view: RunView, state: RunState, plan: RunPlan | null, routeId: string, vehicleId: keyof typeof PLAYER_VEHICLES, result: FinishRunResponse | null): Promise<'shared' | 'saved' | 'failed'> {
  const { stats } = state;
  const vehicle = PLAYER_VEHICLES[plan?.vehicle ?? vehicleId].name;
  const headline = result?.friend?.beaten
    ? `I beat ${result.friend.name}!`
    : plan?.kind === 'daily' && result?.ranks.challenge
      ? `Daily challenge · #${result.ranks.challenge} today`
      : '';
  const card = drawScoreCard(
    {
      score: Math.floor(stats.score),
      newBest: (result?.best ?? 0) <= Math.floor(stats.score),
      routeName: routeById(plan?.routeId ?? routeId).name,
      vehicleName: vehicle,
      metres: stats.metres,
      passengersDropped: stats.passengersDropped,
      netPesewas: shiftNet(stats.faresPesewas, stats.finesPesewas, stats.repairsPesewas, stats.fuelPesewas),
      headline,
      badges: (result?.newBadges ?? []).map((id) => badgeById(id)?.icon ?? '').filter(Boolean),
    },
    view.snapshot(),
    location.origin,
  );
  return shareCardImage(card, `I scored ${Math.floor(stats.score).toLocaleString()} on Trotro Run!`, location.origin);
}
